<template>
    <div class="course-exchange">
        <div class="container">
            <div class="number-container" v-if="exchangeInfoData.code">
                <h3>课程兑换码</h3>
                <div class="number">
                    <input id="inviteCode" type="text" :value="exchangeInfoData.code" readonly />
                    <button class="copy-btn" :data-clipboard-text="exchangeInfoData.code" @click="copy()">复制</button>
                </div>
            </div>
            <div class="content-box">
                <h1>{{exchangeInfoData.qrTitle}}</h1>
                <img :src="exchangeInfoData.qrPic" @touchstart="$emit('saveQrPic')"></img>
                <h4 class="download-button">长按保存二维码</h4>
                <div class="content">
                    <h2>课程兑换流程：</h2>
                    <p>{{exchangeInfoData.wechatGuideDescription}}</p>
                </div>
            </div>
            <div class="bottom-line"></div>
            <img class="close-icon" src="/images/goods/experiencePkg/close-icon.png" @click="$emit('exchangeInfoClose')"
                alt="" />
        </div>
    </div>
</template>
<script>
    import Clipboard from 'clipboard'
    export default {
        name: 'exchangeInfo',
        props: {
            exchangeInfoData: {type: Object,
      default: {}
            }
        },
        data() {
            return {
            }
        },
        // computed: {
        //     infoData(){
        //         console.info(this.exchangeInfoData)
        //         return this.exchangeInfoData
        //     }
        // },
        methods: {
            copy() {
                let self = this
                var clipboard = new Clipboard('.copy-btn');
                clipboard.on('success', function (e) {
                    self.$createToast({
                        txt: "复制成功",
                        type: "txt",
                        time: 2000,
                    }).show();
                });
                clipboard.on('error', function (e) {
                    self.$createToast({
                        txt: "复制失败",
                        type: "txt",
                        time: 2000,
                    }).show();
                });
            }
        }
    }
</script>
<style scoped>
    .course-exchange {
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 10;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(45, 45, 45, 0.75);
    }

    .course-exchange .container {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: inherit;
        width: 301px;
        border-radius: 10px 10px 0 0;
        overflow: hidden;
    }

    .course-exchange .number-container {
        width: 100%;
        height: 107px;
        padding: 12px 16px 26px 20px;
        background-image: url("/images/course/bg00.png");
        background-size: 100%;
        box-sizing: border-box;
    }

    .course-exchange .number-container h3 {
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(36, 67, 82, 1);
        line-height: 20px;
    }

    .course-exchange .number {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 46px;
    }

    .course-exchange input {
        width: 100%;
        height: 38px;
        font-size: 16px;
        font-weight: bold;
        color: rgba(116, 179, 250, 1);
        line-height: 38px;
        padding: 0 10px;
        border-radius: 4px 0 0 4px;
        background-color: #F6FCFF;
        box-sizing: border-box;
    }

    .course-exchange .copy-btn {
        height: 38px;
        width: 70px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 38px;
        background-color: rgba(116, 180, 252, 1);
        box-shadow: 0 1px 15px rgba(97, 183, 241, .6);
    }

    .course-exchange .content-box {
        background-color: #FFF;
        padding: 10px 0 14px;
        border-radius: 0 0 10px 10px;
        margin-top: -2px;
    }

    .course-exchange .bottom-line {
        margin: 0 auto;
        width: 284px;
        height: 10px;
        border-radius: 0 0 8px 8px;
        background-color: rgba(255, 255, 255, 0.5);
    }

    .course-exchange h1 {
        padding: 0px 5px 5px;
        font-size: 12px;
        font-weight: bold;
        color: rgba(36, 67, 82, 1);
        line-height: 17px;
        text-align: center;
    }

    .course-exchange .content-box img {
        display: block;
        width: 140px;
        margin: 0 auto;
    }

    .course-exchange .download-button {
        display: block;
        /* width: 195px; */
        height: 62px;
        text-align: center;
        margin: 0 auto;
        /* background-color: #74B4FC; */
        border-radius: 5px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(36, 67, 82, 1);
        line-height: 62px;
        cursor:pointer;
    }

    .course-exchange h2 {
        font-size: 14px;
        font-weight: 600;
        color: rgba(36, 67, 82, 1);
        line-height: 20px;
        padding: 2px 18px;
    }

    .course-exchange p {
        font-size: 12px;
        font-weight: 400;
        color: rgba(36, 67, 82, 1);
        line-height: 17px;
        margin: 0 18px;
    }

    .course-exchange .close-icon {
        display: block;
        width: 34px;
        margin: 21px auto 0;
    }
</style>